import { CloseButton as CloseButton_ } from "@chakra-ui/react"
import { forwardRef } from "react"
export const CloseButton = forwardRef(({...props}, ref) => {
    return <CloseButton_ ref={ref} {...props}>{props?.children}</CloseButton_>
});